import { ComposeViewState } from 'owa-mail-compose-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setIsDarkMode', function setIsDarkMode(
    viewState: ComposeViewState,
    isDarkMode: boolean
) {
    viewState.isDarkMode = isDarkMode;
});
